import * as React from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
    mql.addEventListener("change", onChange)
    // eslint-disable-next-line react-hooks/set-state-in-effect -- client-only viewport read; cannot run during SSR render
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return !!isMobile
}

/**
 * True once the viewport is wide enough for a list and a detail pane side by
 * side. Undefined until mounted, so the caller renders neither layout on the
 * server and does not flash the wrong one.
 */
export function useIsWide(minWidth = 1024) {
  const [wide, setWide] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const mql = window.matchMedia(`(min-width: ${minWidth}px)`)
    const onChange = () => setWide(mql.matches)
    mql.addEventListener("change", onChange)
    // eslint-disable-next-line react-hooks/set-state-in-effect -- client-only viewport read; cannot run during SSR render
    setWide(mql.matches)
    return () => mql.removeEventListener("change", onChange)
  }, [minWidth])

  return wide
}
